
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.473 2.497a1.2 1.2 0 00-.946 0l-8.4 3.6a1.2 1.2 0 000 2.206L6.3 9.663c.116-.13.26-.237.427-.309l4.8-2.057a1.2 1.2 0 01.946 2.206L9.2 10.905l2.327.998c.302.13.644.13.946 0l8.4-3.6a1.2 1.2 0 000-2.206l-8.4-3.6zM3.972 11.276l2.028.87v4.921a10.78 10.78 0 00-1.26-.208 1.2 1.2 0 01-1.067-1.068 13.337 13.337 0 01.3-4.515zM11.16 19.887a10.831 10.831 0 00-2.76-1.965v-4.748l2.182.935a3.6 3.6 0 002.836 0l6.61-2.833a13.232 13.232 0 01.3 4.515 1.2 1.2 0 01-1.069 1.068 10.762 10.762 0 00-6.419 3.028 1.2 1.2 0 01-1.68 0zM7.2 21.6a1.2 1.2 0 001.2-1.2v-2.478a10.715 10.715 0 00-2.4-.855V20.4a1.2 1.2 0 001.2 1.2z","fill":"#fff"}})])
          )
        }
      }
    